declare namespace $ {

	type $mol_view__dom_name_shm_hitalama_audio_player_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__attr_shm_hitalama_audio_player_2 = $mol_type_enforce<
		({ 
			'src': ReturnType< $shm_hitalama_audio_player['uri'] >,
			'preload': string,
			'aria-label': ReturnType< $shm_hitalama_audio_player['name'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__event_shm_hitalama_audio_player_3 = $mol_type_enforce<
		({ 
			timeupdate( next?: ReturnType< $shm_hitalama_audio_player['sync_time'] > ): ReturnType< $shm_hitalama_audio_player['sync_time'] >,
			loadedmetadata( next?: ReturnType< $shm_hitalama_audio_player['sync_duration'] > ): ReturnType< $shm_hitalama_audio_player['sync_duration'] >,
			durationchange( next?: ReturnType< $shm_hitalama_audio_player['sync_duration'] > ): ReturnType< $shm_hitalama_audio_player['sync_duration'] >,
			seeked( next?: ReturnType< $shm_hitalama_audio_player['sync_duration'] > ): ReturnType< $shm_hitalama_audio_player['sync_duration'] >,
			play( next?: ReturnType< $shm_hitalama_audio_player['sync_playing'] > ): ReturnType< $shm_hitalama_audio_player['sync_playing'] >,
			pause( next?: ReturnType< $shm_hitalama_audio_player['sync_playing'] > ): ReturnType< $shm_hitalama_audio_player['sync_playing'] >,
			ended( next?: ReturnType< $shm_hitalama_audio_player['sync_end'] > ): ReturnType< $shm_hitalama_audio_player['sync_end'] >,
		})  & ReturnType< $mol_view['event'] >
		,
		ReturnType< $mol_view['event'] >
	>
	type $yuf_video_play__checked_shm_hitalama_audio_player_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_audio_player['playing'] >
		,
		ReturnType< $yuf_video_play['checked'] >
	>
	type $yuf_video_slider__value_shm_hitalama_audio_player_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_audio_player['slider_time'] >
		,
		ReturnType< $yuf_video_slider['value'] >
	>
	type $yuf_video_slider__value_max_shm_hitalama_audio_player_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_audio_player['duration'] >
		,
		ReturnType< $yuf_video_slider['value_max'] >
	>
	type $yuf_video_slider__step_shm_hitalama_audio_player_7 = $mol_type_enforce<
		number
		,
		ReturnType< $yuf_video_slider['step'] >
	>
	type $yuf_video_estimate__time_shm_hitalama_audio_player_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_audio_player['time'] >
		,
		ReturnType< $yuf_video_estimate['time'] >
	>
	type $yuf_video_estimate__duration_shm_hitalama_audio_player_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_audio_player['duration'] >
		,
		ReturnType< $yuf_video_estimate['duration'] >
	>
	export class $shm_hitalama_audio_player extends $mol_view {
		sync_time( next?: any ): any
		sync_duration( next?: any ): any
		sync_playing( next?: any ): any
		sync_end( next?: any ): any
		Audio( ): $mol_view
		Play( ): $yuf_video_play
		Slider( ): $yuf_video_slider
		Time( ): $yuf_video_estimate
		uri( ): string
		name( ): string
		playing( next?: boolean ): boolean
		time( next?: number ): number
		slider_time( next?: number ): number
		duration( ): number
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=player.view.tree.d.ts.map